<template>
    <div class="sneos-contact">
        <h3>Thank you!</h3>
    </div>
</template>

<script>
export default {
    name: "thankYou"
}
</script>